var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home'),_c('internshipTechno'),_c('colleges'),_c('approvedby'),_c('opening'),_c('Achievements'),_c('contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }